<div class="card">
  <p-table class="custom-table-container" [scrollable]="validateScrollHeight()"
    [scrollHeight]="validateScrollHeight() ? scrollHeight : undefined"
    [autoLayout]="validateScrollHeight() && !virtualScroll" [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize" rowHover="true" showGridlines="true" [value]="tableData"
    stripedRows>

    <ng-template pTemplate="header">
      <tr class="caption-container" #headerContainer>
        <th [attr.colspan]="dataReport.headers.length" class="p-0 border-0">
          <div class="card p-2" *ngIf="dataReport.captionDescription.length || dataReport.captionFilters.length">
            <div class="caption caption-description ">
              <span *ngFor="let description of dataReport.captionDescription">
                {{ description }}
              </span>
            </div>
            <div class="caption caption-filters">
              <span *ngFor="let filter of dataReport.captionFilters">
                {{ filter }}
              </span>
            </div>
          </div>
        </th>
      </tr>

      <tr #chartsContainerBarVertical *ngIf="showChartsBarVertical && barOptions">
        <th [attr.colspan]="dataReport.headers.length" style="background-color: transparent;">
          <apx-chart [series]="barOptions!.series!" [chart]="barOptions!.chart!" [xaxis]="barOptions!.xaxis!"
            [yaxis]="barOptions!.yaxis!" [dataLabels]="barOptions!.dataLabels!"
            [plotOptions]="barOptions!.plotOptions!">
          </apx-chart>
        </th>
      </tr>

      <tr #chartsContainerLineChart *ngIf="showChartsLineChart && lineOptions">
        <th [attr.colspan]="dataReport.headers.length" style="background-color: transparent;">
          <apx-chart [series]="lineOptions!.series!" [chart]="lineOptions!.chart!" [xaxis]="lineOptions!.xaxis!"
            [yaxis]="lineOptions!.yaxis!" [markers]="lineOptions!.markers!">
          </apx-chart>
        </th>
      </tr>

      <tr>
        <th *ngFor="let header of dataReport.headers" class="column-header"
          [class.separator-column]="showSeparators && header.name === ''">
          <div class="d-flex justify-content-center" [class.separator]="showSeparators && header.name === ''">
            {{ header.name }}
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <ng-container *ngIf="virtualScroll">
        <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: item, depth: item._depth ?? 0 }"></ng-container>
      </ng-container>
      <ng-container *ngIf="!virtualScroll">
        <ng-container *ngTemplateOutlet="recursiveRow; context: { $implicit: item, depth: 0 }"></ng-container>
      </ng-container>
    </ng-template>

    <ng-template pTemplate="footer">
      <tr>
        <td *ngFor="let header of dataReport.headers" [ngStyle]="{'font-weight': 'bold', 'text-align': 'right'}"
          [class.separator-column]="showSeparators && header.name === ''">
          <ng-container *ngIf="isDecimal(dataReport.totals[header.propertyName]); else textValue">
            {{ dataReport.totals[header.propertyName] | number:'1.2-2'}}
          </ng-container>
          <ng-template #textValue>
            {{ dataReport.totals[header.propertyName] }}
          </ng-template>
        </td>
      </tr>
      <ng-container *ngIf="footerTemplate" [ngTemplateOutlet]="footerTemplate"></ng-container>
    </ng-template>
  </p-table>

  <ng-template #rowTpl let-item let-depth="depth">
    <tr
      [ngStyle]="{ 'font-weight': (item.type !== 'detail') && 'bold','background-color': (item.type !== 'detail') && getBackgroundColor(depth) }"
      [ngClass]="{ 'days-mark': (daysMark > 0) && (item.type === 'detail') && (item.days >= daysMark) }">
      <ng-container *ngFor="let header of dataReport.headers; let i = index">
        <td *ngIf="!(item.type !== 'detail' && (item.colspan || 1) > 1 && i > 0 && i < (item.colspan || 1))"
          [attr.colspan]="(item.type !== 'detail' && i === 0) ? (item.colspan || 1) : 1"
          [class.separator-column]="showSeparators && header.name === ''">
          <div [ngStyle]="{
            'padding-left': (header.propertyName === 'name') ? (depth * 5) + 'px' : '5px',
            'text-align': alignColumnText(item[header.propertyName])
          }">
            <ng-container *ngIf="isDecimal(item[header.propertyName]); else textValue">
              {{ item[header.propertyName] | number:'1.2-2'}}
            </ng-container>
            <ng-template #textValue>
              {{ item[header.propertyName] }}
            </ng-template>
          </div>
        </td>
      </ng-container>
    </tr>
  </ng-template>

  <ng-template #recursiveRow let-item let-depth="depth">
    <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: item, depth: depth }"></ng-container>
    <ng-container *ngIf="item.children">
      <ng-container *ngFor="let child of item.children">
        <ng-container *ngTemplateOutlet="recursiveRow; context: { $implicit: child, depth: depth + 1 }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</div>